import { defineStore } from 'pinia'
import api from '@/api'
import Hsystem from './Hsystem'

let userInfo = localStorage.getItem('userInfo')
// console.log(userInfo, 'userInfo')
userInfo = userInfo && userInfo !== 'undefined' ? JSON.parse(userInfo) : { userId: '' }

const user = defineStore('user', {
  state: () => {
    return {
      env: process.env.NODE_ENV,
      isDev: process.env.VUE_APP_MODE === 'development',
      isProd: process.env.VUE_APP_MODE === 'production',
      appHomeName: process.env.VUE_APP_HOME_NAME,
      appName: process.env.VUE_APP_NAME === 'PRICOO' ? 'Pricoo' : 'Haier',
      userInfo: userInfo,
      userShowPage: {
        page: 'orderList',
        data: '',
        selectType: '' // 选中页面
      }, //个人中心显示界面
      defaultAddress: null,
      couponCountInfo: {
        availableCount: 0,
        collectCount: 0,
        countSum: 0
      }, //劵数量
      favoritesNum: 0, // 我的喜欢
      cartCount: 0, // 用户购物车数量
      addressList: [], // 用户收货地址列表
      BClassInfo: {
        executed: false
      }, // 用户B类商品信息
      webDiscountBarInfo: {}, // 网站首页活动信息
      notifications: []
    }
  },
  actions: {
    setUserInfo(val) {
      const prevUserId = this.userInfo?.userId
      this.userInfo = { ...this.userInfo, ...val }
      if (!this.userInfo.nickname) {
        this.userInfo.nickname = this.userInfo.username || 'User'
      }
      localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
      console.log(this.userInfo, 'pinia更改userInfo')
      // 账户变化（登录 / 切换账号 / 401 掉线）才作废首页配置缓存：
      // collected 是账户相关字段，不失效会串显示上一个账号的领取态；
      // 同一 userId 不误清，避免每次导航都白打一次慢接口。
      if (this.userInfo?.userId !== prevUserId) {
        Hsystem().clearHomeData()
      }
    },
    // 退出登录
    setLoginOut(val) {
      // this.tokenExpire = val
      this.token = ''
      this.cartCount = 0
      this.notifications = []
      this.userInfo = { userId: '' }
      this.couponCountInfo = {
        availableCount: 0,
        collectCount: 0,
        countSum: 0
      }
      // 登出/换号：清空首页配置缓存与本地已领取券态，下次进首页必重拉
      // 否则首页缓存会让上一账号的「已领取(Use)」残留到下一账号
      Hsystem().clearHomeData()
      // 退出时清除token
      localStorage.clear()
      localStorage.removeItem('userInfo')
      localStorage.removeItem(`${process.env.NODE_ENV}_token`)
      api.uaa.signOut().then(() => {
        console.log('退出成功')
      })
    },
    // 更新token
    setToken(token) {
      // if (token) {
      //   this.token = token
      //   util.storage.set(config.tokenKey, token)
      //   // uni.setStorage({ key: config.tokenKey, data: token })
      // } else {
      //   this.token = ''
      //   // 退出时清除token
      //   util.storage.remove(config.tokenKey)
      //   // uni.removeStorage({ key: config.tokenKey })
      // }
    },
    setUserShowPage(val) {
      console.log(val, 'this.userShowPage')
      this.userShowPage = { ...this.userShowPage, ...val }
    },
    // 更新劵数量
    getCouponCountInfo() {
      if (!this.userInfo.userId) return
      api.coupon.getCouponCount().then((res) => {
        this.couponCountInfo = res
      })
    },
    // 更新收藏数量
    setCollectProduct(val) {
      this.favoritesNum = val
    },
    setAddressList(val) {
      this.addressList = val
      // console.log(this.addressList, 'this.addressList')
      // const defAddress = this.addressList.find(x => x.defAddress) || {}
      // if (!defAddress.id) return
      // this.setDefaultAddress(defAddress)
    },
    setDefaultAddress(defAddress) {
      this.defaultAddress = defAddress
      console.log('defaultAddress set:', this.defaultAddress)
    },
    getCartList() {
      if (!this.userInfo.userId) return
      api.product
        .getCartCount({
          'userId.equals': this.userInfo.userId
        })
        .then((res) => {
          this.cartCount = res
          console.log('查看购物车数量:', this.cartCount)
        })
    },
    updataCartList(val) {
      this.cartCount = val
    },
    setBClassInfo(val) {
      this.BClassInfo = val
    },
    updateDiscountBarInfo(value) {
      this.webDiscountBarInfo = { ...this.webDiscountBarInfo, ...value }
      // console.log('webDiscountBarInfo', this.webDiscountBarInfo)
    },
    getNotifications() {
      api.order.getOrderReceivedMsg().then((res) => {
        console.log(res, 'getOrderReceivedMsg')
        this.notifications = res
      })
    }
  },
  persist: {
    enabled: true,
    // 选择存储方式和内容
    strategies: [{ storage: localStorage, paths: ['addressList'] }]
  }
})

export default user
